<div class=" fnt-change">
   <button (click)="getCategoryValues()">All</button>
   <div *ngFor="let item of data">
      <button (click)="getCategoryValue(item)">{{item}}</button>
   </div>
  
</div>
<div class="closs-icon">
   <tc-icon class="row float-right" [iconClass]="'icofont-close-line'" (click)="closeModal()" [tcFontSize]="30">
   </tc-icon>
</div>



<style>
   @media only screen and (min-width: 1300px) {
      .container {
         width: 350px;
         max-width: 100%;
         padding: 20px;
         margin-left: 50px;
      }

      p.form_text1>span {
         display: inline-block;
         min-width: 120px;
      }

      ::ng-deep .mat-bottom-sheet-container-large {
         box-sizing: border-box;
         display: block;
         outline: 0;
         /* height: 500px !important; */
         border-top-left-radius: 16px !important;
         border-top-right-radius: 16px !important;
         min-height: 100px !important;
         max-height: 300px !important;
      }
   }

   @media only screen and (max-width:767px) {
      .nav-tabs1 {
         color: #479943;
         background-color: #fff;
         border-color: #dee2e6 #dee2e6 #fff;
         font-size: 10px;
         padding: 0px;
         font-weight: 600;
      }
   }

   @media only screen and (max-width:375px) {
      .container {
         width: 360px;
         margin-left: -24px;
      }
   }

   @media only screen and (min-width: 600px) {
      .container {
         width: 350px;
         max-width: 100%;
      }
   }

   .float-right {
      margin-top: -31px !important;
   }

   .fnt-change {
      margin-top: -30px !important;
      padding: 36px 0px 0px 20px !important;
   }

   .fnt-change p {
      color: #4E4E4E !important;
      font-weight: 500;
      font-size: 16px;
      margin: 10px;
      margin-left: 30px;
   }

   .fnt-change button {
      border-top: none;
      background: transparent;
      width: 86%;
      text-align: left;
      border-left: none;
      border-right: none;
      border-bottom: none;
      /* border-bottom: 0.7px solid gainsboro; */
      padding: 10px;
      cursor: pointer;
   }

   ::ng-deep.mat-bottom-sheet-container {
      /* padding: 36px 0px 0px 20px !important; */
      min-width: 100vw;
      box-sizing: border-box;
      display: block;
      outline: 0;
      /* max-height: 600vh !important; */
      overflow: auto;
      border-top-left-radius: 16px !important;
      border-top-right-radius: 16px !important;
   }

   ::ng-deep.mat-bottom-sheet-container-large {
      min-width: 380px;
      max-width:380px;
      /* max-width: calc(100vw - 256px); */
      min-height: 100px !important;
      max-height: 250px !important;
   }
   ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        max-width:380px;
        /* max-width: calc(100vw - 384px); */
    }
   .closs-icon {
      position: sticky;
      right: 23px;
      bottom: 20px;
      /* padding-bottom: 16px; */
      padding-right: 22px;
   }

   .hrLine {
      margin: 15px 35px 15px 5px;
   }

   ::ng-deep::-webkit-scrollbar {
  display: none !important;
}
   tc-icon {
      cursor: pointer;
   }
</style>